import {
  GET_ALL_PRODUCT_CATEGORIES_RESPONSE_SUCCESS,
  GET_ALL_PRODUCT_CATEGORIES,
} from "./actionTypes"

export const getAllProductCategories = () => {
  return {
    type: GET_ALL_PRODUCT_CATEGORIES,
  }
}
export const getAllProductCategoriesResponseSuccess = payload => ({
  type: GET_ALL_PRODUCT_CATEGORIES_RESPONSE_SUCCESS,
  payload: payload,
})
